/**
 * Parses fraction or decimal string to number
 * Supports formats: "1/2", "1 1/2", "0.5"
 */
export function parseFractionToDecimal(input: string | number): number {
  if (typeof input === 'number') {
    return input;
  }

  if (!input || typeof input !== 'string') {
    return 0;
  }

  const trimmed = input.trim();

  // Handle decimal
  if (!trimmed.includes('/')) {
    const decimal = parseFloat(trimmed);
    return isNaN(decimal) ? 0 : decimal;
  }

  // Handle mixed fraction (e.g., "1 1/2")
  const mixedMatch = trimmed.match(/^(\d+)\s+(\d+)\/(\d+)$/);
  if (mixedMatch) {
    const whole = parseInt(mixedMatch[1]);
    const numerator = parseInt(mixedMatch[2]);
    const denominator = parseInt(mixedMatch[3]);
    if (denominator === 0) return whole || 0;
    return whole + numerator / denominator;
  }

  // Handle simple fraction (e.g., "1/2")
  const fractionMatch = trimmed.match(/^(\d+)\/(\d+)$/);
  if (fractionMatch) {
    const numerator = parseInt(fractionMatch[1]);
    const denominator = parseInt(fractionMatch[2]);
    if (denominator === 0) return 0;
    return numerator / denominator;
  }

  // Invalid format
  return 0;
}
